/**
 * Exit model
 */

export class Exit {
    Direction: string = "Empty";
    bActive: boolean = false;
    DestinationRoom: string = "";
    PortalObjectName: string = "<None>";

    cloneForDiff(): {
        bActive: boolean;
        DestinationRoom: string;
        PortalObjectName: string;
    } {
        return {
            bActive: this.bActive,
            DestinationRoom: this.DestinationRoom,
            PortalObjectName: this.PortalObjectName,
        };
    }
}

export function SetupExitData(GameData: any[]): Exit {
    const CurExit = new Exit();
    CurExit.Direction = GameData[0];
    CurExit.bActive = GameData[1];
    CurExit.DestinationRoom = GameData[2];
    CurExit.PortalObjectName = GameData[3];
    return CurExit;
}
